import StatisticIndicatorType from "../../statistic/models/StatisticIndicatorType";

export interface SubscriptionDetailsModel {
    area: number;
    fields: number;
}

export interface ContractsModel {
    id: number;
    ha_limitation: number | null;
    name: string;
    commercial_package_id?: number;
    organisation_id?: number;
    campaign_id: number;
    status: string;
    subscriptions_details: SubscriptionDetailsModel;
    indicators?: StatisticIndicatorType[] | null;
    created_at: Date;
    updated_at: Date;
    external_ref?: any;
}

export enum ContractsStatus {
    ACTIVE = 'active',
    INACTIVE = 'inactive',
    CANCELED = 'canceled',
}

export interface PostContractsModel {
    id?: number;
    ha_limitation: number | null;
    name: string;
    commercial_package_id?: number | null;
    organisation_id?: number | null;
    campaign_id: number | null;
    indicators?: StatisticIndicatorType[] | null;
}

export enum DeleteType {
    DELETE = 'delete',
    CANCEL = 'cancel',
}
export interface DeleteContractsResponse {
    type: DeleteType;
    data: ContractsModel;
}
